import React, { Component, PropTypes } from 'react';
import styles from './text-slider.scss';
import CSSModules from 'react-css-modules';
import { isDesktop } from '../../../common';

class TextSlider extends Component {

    static propTypes = {
        children: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.delta = 0;

        this.state = {
            shouldAnimate: false,
            slideX: 0,
        };
    }

    componentDidMount() {
        if (isDesktop()) {
            const outerWidth = this.refs.outerTextSlider.offsetWidth;
            this.refs.innerTextSlider.style.position = 'absolute';
            const innerWidth = this.refs.innerTextSlider.offsetWidth;
            this.refs.innerTextSlider.style.position = 'relative';

            if ((outerWidth - innerWidth) < 0) {
                this.delta = outerWidth - innerWidth;
                this.setState({ shouldAnimate: true });
            }
        }
    }

    startSliding = () => {
        if (this.state.shouldAnimate) {
            this.setState({ slideX: this.delta });
        }
    };

    stopSliding = () => {
        if (this.state.shouldAnimate) {
            this.setState({ slideX: 0 });
        }
    };

    render(){
        const style = this.state.shouldAnimate ? { transform: `translateX(${ this.state.slideX }px)` } : {};

        return (
            <div
                ref="outerTextSlider"
                styleName="textSliderWrapper"
                onMouseOver={this.startSliding}
                onMouseOut={this.stopSliding}
            >
                <div ref="innerTextSlider" styleName="textSlider" style={style}>
                    {this.props.children}
                </div>
                {
                    (this.state.shouldAnimate && this.state.slideX === 0) &&
                    <div styleName="gradient" />
                }
            </div>
        );
    }
}

export default CSSModules(TextSlider, styles);



// WEBPACK FOOTER //
// ./app/components/shared/TextSlider/index.jsx